const agent_attorney_uischema = {
  view: "main",
  title: "Agent/Attorney (Firm) Profiles",
  entity: "Firms",
  linkBack: {
    name: "Back to Profiles",
    link: "/dashboard/profiles/",
  },
  button: {
    name: "New Firm",
    style: "default",
  },
};

export default agent_attorney_uischema;
